import { DEFAULT_REFRESH, FRANCETV_ENDPOINT_FN } from './types/index';

export const setPromiseTimeout = (cb, delay) => new Promise((res) => setTimeout(() => res(cb()), delay));

export const createState = (state = {}) => [
  state,
  (stateUpdate) => Object.entries(stateUpdate).forEach(([key, val]) => {
    if (val !== null) state[key] = val; /* eslint-disable-line */
  })
];

/**
 * Check if the provided live program has changed
 * @param {*} prev
 */
export const programHasChanged = (prev) => (next) => (
  Boolean(next.beginDate && next.endDate && next.duration && next.progress)
  && ['beginDate', 'endDate'].reduce((val, curr) => (val && (prev[curr] !== next[curr])), true)
);

export const fetchMetaData = async (channelId, validate, config = {}) => {
  const cf = { buildURL: FRANCETV_ENDPOINT_FN, refresh: DEFAULT_REFRESH, ...config };
  try {
    const metadata = await (await fetch(cf.buildURL(channelId))).json();
    if (!validate(metadata)) throw new Error('Metadata sync error');
    return metadata;
  } catch (e) {
    return setPromiseTimeout(() => fetchMetaData(channelId, validate, cf), cf.refresh);
  }
};

/**
 * Convert fetch body to json
 * @param {*} data
 */
export const toJson = async (data) => data?.json();
